import React from 'react';
import { motion } from 'framer-motion';
import { Check } from 'lucide-react';
export function BonusStack() {
  const bonuses = [{
    num: 1,
    icon: '🛒',
    title: 'Lista de Compras Perfecta',
    subtitle: 'Walmart / Costco ',
    value: '$17 USD',
    bullets: ['Lista completa organizada por secciones', 'Precios estimados en dólares y pesos', 'Guía de lectura de etiquetas en 10 segundos']
  }, {
    num: 2,
    icon: '📊',
    title: 'Checklist Diario de Bioseñales 40+',
    subtitle: 'Tu Termómetro Hormonal Personal',
    value: '$12 USD',
    bullets: ['Tracker de 30 días con 7 bioseñales clave', 'Semáforo de progreso semana a semana', 'Tabla de mediciones físicas comparativas']
  }, {
    num: 3,
    icon: '🌮',
    title: 'Guía de Sustitutos Latinos Saludables',
    subtitle: 'Come lo que Amas, Versión Metabólica',
    value: '$17 USD',
    bullets: ['30 sustitutos con índice glucémico comparado', 'Enchiladas, tacos y pozole en versión metabólica', 'Cambios que tu familia no notará']
  }, {
    num: 4,
    icon: '⏱️',
    title: 'Plan de Comidas Rápidas de 15 Minutos',
    subtitle: 'Para Mujeres con Prisa que Merecen Resultados',
    value: '$22 USD',
    bullets: ['Desayunos en 5-8 min, comidas en 10-12 min', 'Plan de Batch Cooking Dominical de 2 horas', 'Macros aproximados sin contar ni medir']
  }, {
    num: 5,
    icon: '🥤',
    title: 'Recetario de Licuados Metabólicos',
    subtitle: 'Energía Pura Sin Picos de Azúcar',
    value: '$17 USD',
    bullets: ['10 licuados con fórmula proteína + grasa + fibra', 'Los 5 errores que convierten tu smoothie en bomba de azúcar', 'Plan de licuados semanal día a día']
  }];
  return <section className="w-full bg-lightGray py-20 px-4" data-id="element-17">
      <div className="max-w-[960px] mx-auto" data-id="element-18">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-12" data-id="element-19">
          <h2 className="text-[28px] md:text-[34px] font-bold text-dark inline-block relative" data-id="element-20">
            Y Eso No Es Todo... También Recibes ESTOS 5 Bonus Gratis:
            <div className="absolute -bottom-2 left-0 w-full h-1.5 bg-orange opacity-60 rounded-full" data-id="element-21"></div>
          </h2>
          <p className="text-[17px] text-[#555] mt-6" data-id="element-22">
            Diseñados para eliminar cada obstáculo que podría frenarte
          </p>
        </motion.div>

        <div className="flex flex-col gap-6" data-id="element-23">
          {bonuses.map((bonus, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-white rounded-2xl shadow-[0_2px_16px_rgba(0,0,0,0.07)] p-6 md:p-8 flex flex-col md:flex-row gap-6 md:gap-8" data-id="element-24">
              {/* Left Column */}
              <div className="flex flex-col items-center md:items-start md:w-1/4 md:border-r md:border-gray-100 md:pr-6" data-id="element-25">
                <span className="text-teal font-bold text-lg mb-2" data-id="element-26">
                  BONUS #{bonus.num}
                </span>
                <span className="text-[48px] leading-none" data-id="element-27">{bonus.icon}</span>
              </div>

              {/* Center Column */}
              <div className="flex-1" data-id="element-28">
                <h3 className="text-[22px] font-bold text-dark mb-1" data-id="element-29">
                  {bonus.title}
                </h3>
                <p className="text-[15px] text-teal italic mb-4" data-id="element-30">
                  {bonus.subtitle}
                </p>

                <p className="font-bold text-sm text-dark mb-2" data-id="element-31">
                  Lo que obtienes:
                </p>
                <ul className="space-y-2" data-id="element-32">
                  {bonus.bullets.map((bullet, i) => <li key={i} className="flex items-start gap-2" data-id="element-33">
                      <Check className="w-4 h-4 text-lime mt-0.5 flex-shrink-0" data-id="element-34" />
                      <span className="text-[15px] text-[#555] leading-[1.7]" data-id="element-35">
                        {bullet}
                      </span>
                    </li>)}
                </ul>
              </div>

              {/* Right Column */}
              <div className="md:w-1/4 flex flex-col items-center justify-center bg-orange-light/50 rounded-xl p-4 border border-orange/10" data-id="element-36">
                <span className="text-gray-400 line-through text-[16px] mb-1" data-id="element-37">
                  {bonus.value}
                </span>
                <span className="text-[28px] font-bold text-orange leading-none mb-1" data-id="element-38">
                  GRATIS
                </span>
                <span className="text-[12px] text-gray-500" data-id="element-39">
                  con tu compra hoy
                </span>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}